{
  "fields": {
    "supplier": "المورد",
    "purchase": "فاتورة الشراء",
    "createdBy": "سجّله"
  },
  "picker": {
    "placeholder": "اختر موردًا",
    "search": "ابحث بالاسم أو الرمز أو رقم الجوال…",
    "empty": "لا يوجد مورد مطابق.",
    "failed": "تعذّر تحميل الموردين. حاول مرة أخرى."
  },
  "list": {
    "supplierFilter": "التصفية حسب المورد",
    "allSuppliers": "جميع الموردين",
    "unitFilter": "الوحدة الطالبة",
    "allUnits": "جميع الوحدات",
    "emptyFilteredBody": "جرّب بحثًا أو موردًا أو فترة أخرى.",
    "export": "تصدير العرض",
    "exportHint_zero": "لا مستندات في هذا العرض",
    "exportHint_one": "ملف CSV بالمستند الوحيد في هذا العرض",
    "exportHint_two": "ملف CSV بالمستندين في هذا العرض",
    "exportHint_few": "ملف CSV بـ {{n}} مستندات في هذا العرض",
    "exportHint_many": "ملف CSV بـ {{n}} مستندًا في هذا العرض",
    "exportHint_other": "ملف CSV بـ {{n}} مستند في هذا العرض",
    "exported_zero": "لم يُصدَّر أي مستند",
    "exported_one": "صُدّر مستند واحد",
    "exported_two": "صُدّر مستندان",
    "exported_few": "صُدّرت {{n}} مستندات",
    "exported_many": "صُدّر {{n}} مستندًا",
    "exported_other": "صُدّر {{n}} مستند",
    "exportedView": "صُدّر العرض",
    "mine": "مستنداتي",
    "rowActions": "إجراءات {{number}}",
    "methodFilter": "تصفية حسب طريقة الدفع",
    "allMethods": "كل الطرق",
    "accountFilter": "تصفية حسب حساب النقد أو البنك",
    "allAccounts": "كل الحسابات"
  },
  "errors": {
    "PURCHASE_POSTED": "لا يمكن تعديل أو ترحيل أو حذف إلا مسودة فاتورة شراء. فاتورة الشراء المرحّلة يمكن إبطالها فقط.",
    "SUPPLIER_REQUIRED": "اختر المورد أولًا. يمكن حفظ المسودة دون مورد، لكن لا يمكن ترحيلها أو إرسالها للاعتماد حتى يُحدَّد موردها.",
    "SUPPLIER_HIDDEN": "الموردون مخفيون عنك، فلا يمكنك اختيار مورد أو تغييره أو التصفية أو الترتيب حسب المورد. احفظ فاتورة الشراء دون مورد، وسيضيفه من يملك صلاحية عرض الموردين.",
    "PURCHASE_NOT_POSTED": "لا يمكن إبطال فاتورة شراء أو سدادها أو إرجاع بضاعتها إلا بعد ترحيلها.",
    "PURCHASE_HAS_RETURNS": "صدرت مرتجعات مشتريات على فاتورة الشراء هذه. أبطِلها أولًا.",
    "PURCHASE_HAS_PAYMENTS": "هناك دفعات مطبّقة على فاتورة الشراء هذه. أزلها من تلك الدفعات أولًا.",
    "PURCHASE_HAS_RETURN_CREDITS": "هناك مرتجع مورد مطبّق على فاتورة الشراء هذه. أزله من تسويات الفاتورة، أو ألغِ ذلك المرتجع، أولًا.",
    "STOCK_ISSUED_SINCE_RECEIPT": "بيع بعض هذه البضاعة أو صُرف منذ استلامها بمتوسط التكلفة، وإخراجها الآن بتكلفة الشراء سيترك قيمة في المخزون دون كمية مقابلها. صحّح المخزون بتسوية مخزون بدلًا من ذلك.",
    "DRAFT_OUTDATED": "أُرشف منتج في هذه المسودة بعد حفظها. اختر منتجًا نشطًا واحفظ المسودة ثم رحّلها من جديد.",
    "STOCK_ALREADY_USED": "بيع بعض البضاعة التي أدخلتها فاتورة الشراء هذه أو نُقل. أرجعها إلى المورد بدلًا من إبطال الفاتورة.",
    "STOCK_NOT_ON_HAND": "بعض هذه البضاعة لم يعد موجودًا في المستودع، فلا يمكن إرجاعه إلى المورد.",
    "SUPPLIER_INACTIVE": "هذا المورد غير نشط أو مؤرشف. أعد تنشيطه قبل ترحيل فاتورة شراء منه.",
    "SUPPLIER_ARCHIVED": "هذا المورد مؤرشف. استعِد المورد أولًا.",
    "SUPPLIER_RETURN_POSTED": "لا يمكن تعديل أو ترحيل أو حذف إلا مسودة مرتجع مشتريات.",
    "SUPPLIER_RETURN_NOT_POSTED": "لا يمكن إبطال مرتجع المشتريات أو تطبيقه إلا بعد ترحيله.",
    "CREDIT_EXCEEDS_PURCHASE": "قيمة المرتجع أكبر من المتبقي القابل للإرجاع أو الخصم على فاتورة الشراء.",
    "RETURN_EXCEEDS_PURCHASED": "إحدى الكميات أكبر مما يمكن إرجاعه من فاتورة الشراء.",
    "RETURN_SHARE_TOO_SMALL": "أرجع هذا البند بكميات أكبر: مبالغ الوحدة الواحدة أقل من بيسة واحدة.",
    "ALLOCATION_EXCEEDS_BALANCE": "أحد المبالغ أكبر من المتبقي على فاتورة الشراء الخاصة به.",
    "ALLOCATION_EXCEEDS_PAYMENT": "مجموع المبالغ أكبر من المتبقي في هذه الدفعة.",
    "ALLOCATION_EXCEEDS_CREDIT": "مجموع المبالغ أكبر من المتبقي في مرتجع المشتريات هذا.",
    "SOURCE_REFUNDED": "استرددنا من المورد جزءًا من هذا الرصيد. أبطِل عملية الاسترداد تلك أولًا.",
    "NO_MAIN_WAREHOUSE": "لم يُحدَّد مستودع رئيسي. اطلب من المسؤول اختياره من المخزون › المستودعات.",
    "WHOLE_UNITS_ONLY": "منتج يُعدّ بوحدات كاملة كُتبت كميته بكسور.",
    "REFUND_EXCEEDS_CREDIT": "أحد المبالغ أكبر مما تبقى للاسترداد في مصدره.",
    "ORG_UNIT_REQUIRED": "اختر الوحدة التنظيمية التي تخصها هذه المشتريات.",
    "ORG_UNIT_OUT_OF_SCOPE": "هذه الوحدة التنظيمية خارج الوحدات التي تعمل لها. اختر إحدى وحداتك.",
    "CHEQUE_CLEARED": "صرف البنك شيك هذه الدفعة. تراجع عن صرف الشيك أولًا.",
    "CHEQUE_NOT_CLEARED": "لم يصرف البنك شيك هذه الدفعة بعد. استرد رصيدها بعد أن يصرف البنك الشيك."
  },
  "lines": {
    "cost": "تكلفة الوحدة",
    "costInclusive": "التكلفة شاملة الضريبة",
    "costOf": "تكلفة وحدة البند {{n}}",
    "account": "يُحمَّل على",
    "accountOf": "حساب البند {{n}}",
    "defaultAccount": "المصروفات التشغيلية (افتراضي)",
    "searchAccounts": "ابحث برمز الحساب أو اسمه…",
    "noAccounts": "لا يوجد حساب مصروفات أو أصول مطابق.",
    "inventory": "المخزون (بضاعة)",
    "fromProduct": "البضاعة: المخزون. الخدمات: المصروفات التشغيلية.",
    "accountKept": "يبقى الحساب المختار في المسودة",
    "enterHint": "Enter في البند الأخير يضيف بندًا جديدًا. يبدأ المنتج بآخر تكلفة شراء له (أو بمتوسط تكلفته)، فطابِقها مع فاتورة المورد.",
    "costHint": {
      "last": "آخر تكلفة {{cost}} ({{date}})",
      "average": "المتوسط {{cost}}",
      "none": "لم يُشترَ من قبل",
      "exVat": "دون الضريبة"
    },
    "sellPrice": {
      "sells": "سعر البيع {{price}}",
      "margin": "الهامش {{margin}}",
      "editOf": "تغيير سعر بيع البند {{n}}",
      "title": "سعر البيع",
      "label": "سعر التجزئة لكل {{unit}} دون الضريبة",
      "hint": "يُحفظ في المنتج فورًا لنقطة البيع والفواتير، ولا يتغير هذا الشراء.",
      "save": "حفظ السعر"
    }
  },
  "allocations": {
    "source": "سُدّدت بموجب",
    "payment": "دفعة",
    "supplierReturn": "مرتجع مشتريات",
    "purchase": "فاتورة شراء"
  },
  "allocate": {
    "limited": "تُعرض أقدم {{n}} فاتورة شراء مفتوحة.",
    "noOpen": "لا توجد فواتير شراء مفتوحة لهذا المورد.",
    "noOpenBody": "يبقى المبلغ كاملًا دفعة مقدّمة لدى المورد لتُطبّق على فواتير شراء لاحقة.",
    "tableLabel": "فواتير الشراء المفتوحة",
    "overBalance": "أكبر من المتبقي على فاتورة الشراء هذه.",
    "exceedsPayment": "مجموع المبالغ المطبّقة أكبر من الدفعة. خفّضها أو ارفع المبلغ.",
    "refunded": "مسترد من المورد",
    "refundedShort": "المسترد"
  },
  "print": {
    "purchase": "فاتورة شراء",
    "supplierReturn": "إشعار مدين",
    "allowance": "إشعار مدين",
    "supplier": "المورد",
    "supplierCode": "رمز المورد",
    "debitTo": "مدين على",
    "date": "التاريخ",
    "voidBanner": "ملغى — هذا السند لاغٍ",
    "paymentVoucher": "سند صرف",
    "refundVoucher": "سند قبض",
    "paidTo": "صُرف إلى",
    "receivedFrom": "استلمنا من",
    "supplierVat": "الرقم الضريبي",
    "payeeBank": "الحساب البنكي للمورد",
    "theSumOf": "مبلغ وقدره",
    "method": "طريقة الدفع",
    "fromAccount": "صُرف من",
    "intoAccount": "أُودع في",
    "reference": "رقم الشيك أو المرجع",
    "paymentOf": "وذلك عن",
    "refundOf": "وذلك استردادًا لـ",
    "onAccountOnly": "دفعة مقدمة لم تُطبّق بعد",
    "billNo": "فاتورة المورد",
    "advance": "دفعة مقدمة لدى المورد",
    "preparedBy": "أعدّه",
    "receivedBy": "استلمه",
    "approvedBy": "اعتمده",
    "receivedBySupplier": "المستلم (المورد)"
  },
  "purchases": {
    "title": "فواتير الشراء",
    "subtitle": "فواتير الموردين عن البضائع والخدمات المستلمة: المسودات والفواتير المرحّلة وما زلنا ندين به.",
    "kind": "فاتورة شراء",
    "new": "فاتورة شراء جديدة",
    "newTitle": "فاتورة شراء جديدة",
    "newSubtitle": "تُحفظ مسودةً. ترحيلها يُدخل البضاعة إلى المخزون ويمنحها رقمًا.",
    "editTitle": "تعديل {{title}}",
    "editSubtitle": "تعديل المسودة",
    "draftTitle": "مسودة فاتورة شراء",
    "noSupplierYet": "لم يُحدَّد المورد بعد",
    "chooseSupplier": "اختر المورد",
    "supplierHidden": "المورد مخفي",
    "supplierHiddenHint": "لا تملك صلاحية عرض الموردين. احفظ المسودة، وسيضيف المورد ويرحّلها من يملكها.",
    "supplierToPost": "اختر المورد قبل الترحيل. يمكنك حفظ المسودة دونه.",
    "supplierToPostHidden": "تُرحَّل فاتورة الشراء مع موردها: يضيفه من يملك صلاحية عرض الموردين.",
    "saveDraft": "حفظ المسودة",
    "notDraftTitle": "لم تعد فاتورة الشراء هذه مسودة",
    "backToPurchase": "العودة إلى فاتورة الشراء",
    "voidTitle": "فاتورة الشراء هذه مُبطَلة",
    "draftNote": "هذه مسودة: ليس لها رقم، والبضاعة لم تدخل المخزون، ولم يُسجَّل شيء في الدفاتر بعد. رحّلها عند وصول البضاعة وفاتورة المورد.",
    "balance": "المستحق للمورد",
    "noSettlements": "لم يُدفع شيء على فاتورة الشراء هذه بعد.",
    "noSettlementsHint": "سجّل الدفعة للمورد لتسويتها.",
    "mainWarehouse": "المستودع الرئيسي",
    "mainWarehouseNamed": "المستودع الرئيسي ({{code}})",
    "noUnit": "بلا وحدة",
    "warehouseNamed": "المستودع {{code}}",
    "chargedTo": "يُحمَّل على {{account}}",
    "searchLabel": "البحث في فواتير الشراء",
    "searchPlaceholder": "ابحث بالرقم أو رقم فاتورة المورد أو المورد…",
    "views": {
      "label": "عروض المشتريات",
      "all": "الكل",
      "drafts": "المسودات",
      "open": "المفتوحة",
      "overdue": "المتأخرة",
      "void": "الملغاة",
      "owed": "مستحق"
    },
    "empty": {
      "all": "لا توجد مشتريات بعد.",
      "body": "سجّل فاتورة المورد عن البضائع أو الخدمات التي استلمتها.",
      "drafts": "لا توجد مسودات مشتريات.",
      "open": "لا شيء بانتظار الدفع.",
      "overdue": "لا شيء متأخر.",
      "void": "لا توجد مشتريات ملغاة.",
      "mine": "ليست لديك مسودات مشتريات."
    },
    "sections": {
      "purchase": "فاتورة الشراء",
      "summary": "ملخص",
      "settlements": "الدفعات والمرتجعات",
      "returns": "مرتجعات المشتريات الصادرة عليها",
      "attachments": "المرفقات",
      "document": "مستند الشراء"
    },
    "fields": {
      "purchaseDate": "تاريخ الشراء",
      "dueDate": "تاريخ الاستحقاق",
      "supplierReference": "رقم فاتورة المورد",
      "warehouse": "الاستلام في",
      "supplierReferenceShort": "مرجع المورد",
      "orgUnit": "الوحدة الطالبة",
      "orgUnitShort": "الوحدة"
    },
    "hints": {
      "supplierReference": "الرقم المدوّن على فاتورة المورد نفسه.",
      "supplierOptional": "يمكن حفظ المسودة دون مورد، أما الترحيل فيتطلبه.",
      "dueDate": "بعد {{days}} يومًا من تاريخ الشراء ما لم تختر تاريخًا آخر.",
      "warehouse": "تدخل البضاعة هذا المستودع عند ترحيل فاتورة الشراء.",
      "warehouseTagged": "لا تدخل هذا المستودع إلا البضاعة غير المرتبطة بمشروع؛ أما المرتبطة بمشروع فتذهب مباشرة إلى موقعه.",
      "orgUnit": "الجزء من الجهة الذي تخصه فاتورة الشراء. تحدد من يعتمدها ومن يمكنه الاطلاع عليها.",
      "lines": "ابحث عن منتج بالاسم أو رمز الصنف أو الباركود، أو اكتب وصف خدمة أو مصروف بنفسك. تُحمَّل الخدمات والبنود النصية على حساب مصروفات.",
      "notes": "لسجلاتك الخاصة؛ لا تُرسل إلى المورد."
    },
    "actions": {
      "post": "ترحيل فاتورة الشراء",
      "void": "إبطال فاتورة الشراء",
      "delete": "حذف المسودة",
      "recordPayment": "تسجيل دفعة",
      "createReturn": "مرتجع أو خصم",
      "postMenu": "ترحيل…",
      "deleteMenu": "حذف المسودة…",
      "voidMenu": "إلغاء…",
      "duplicate": "نسخ",
      "reissue": "إصدارها من جديد كمسودة"
    },
    "post": {
      "title": "ترحيل فاتورة الشراء هذه من {{supplier}}؟",
      "mainWarehouse": "المستودع الرئيسي",
      "body": "الإجمالي {{total}}. يمنحها الترحيل رقمًا، ويُدخل البضاعة إلى {{warehouse}} بتكلفتها الصافية (بعد الخصم ودون الضريبة)، ويسجّل {{total}} مستحقة للمورد. لا يمكن تعديلها بعد ذلك، بل إبطالها فقط.",
      "noReference": "رقم فاتورة المورد فارغ: سيصعب العثور على الفاتورة لاحقًا.",
      "duplicate_zero": "فاتورة المورد {{reference}} مسجلة على {{numbers}}.",
      "duplicate_one": "فاتورة المورد {{reference}} مسجلة على {{numbers}}.",
      "duplicate_two": "فاتورة المورد {{reference}} مسجلة على {{numbers}}.",
      "duplicate_few": "فاتورة المورد {{reference}} مسجلة على {{numbers}}.",
      "duplicate_many": "فاتورة المورد {{reference}} مسجلة على {{numbers}}.",
      "duplicate_other": "فاتورة المورد {{reference}} مسجلة على {{numbers}}.",
      "capture": {
        "title": "ما زال للمراجعة",
        "intro": "هذه نقاط من القراءة لم تُراجَع بعد. يمكنك الترحيل الآن، أو الرجوع لتصحيحها أولًا.",
        "line": "البند {{n}}: {{issues}}",
        "goToLine": "الانتقال إلى البند {{n}}",
        "goTo": "الانتقال إليه",
        "totalGap": "الفرق بين مجموع البنود وإجمالي الفاتورة {{difference}}",
        "totalGapNet": "الفرق بين صافي البنود وصافي الفاتورة {{difference}}",
        "issues": {
          "NO_PRODUCT": "لم يُطابَق بمنتج",
          "PRODUCT_UNAVAILABLE": "المنتج غير متاح للشراء",
          "LOW_CONFIDENCE": "المساعد لم يكن متأكدًا",
          "QUANTITY_UNREADABLE": "لم تُقرأ الكمية",
          "PRICE_FROM_TOTAL": "السعر محسوب من إجمالي البند",
          "PRICE_LAST_COST": "السعر هو التكلفة المسجّلة",
          "PRICE_MISSING": "بلا سعر",
          "WHOLE_UNITS": "كسر من وحدة تُعدّ كاملة",
          "LINE_TOTAL_MISMATCH": "إجمالي البند مختلف",
          "TAX_RATE_UNKNOWN": "نسبة الضريبة تحتاج مراجعة"
        }
      }
    },
    "delete": {
      "title": "حذف هذه المسودة؟",
      "body": "تُحذف مسودة فاتورة الشراء. لم يُستلم أو يُسجَّل شيء بعد."
    },
    "void": {
      "title": "إبطال {{number}}؟",
      "body": "يُعكس قيدها اليومي وتخرج البضاعة التي أدخلتها من المخزون مجددًا. يُرفض الإبطال ما دامت عليها دفعات أو مرتجعات مطبّقة، أو إذا بيع شيء من بضاعتها أو نُقل. تبقى فاتورة الشراء في السجلات بحالة مُبطَلة.",
      "blocked": "هناك دفعات أو مرتجعات مطبّقة على فاتورة الشراء هذه. أزلها أولًا وإلا رُفض الإبطال.",
      "removeFirst_zero": "أزل أولًا الدفعات المطبّقة عليها.",
      "removeFirst_one": "أزل أولًا الدفعة المطبّقة عليها.",
      "removeFirst_two": "أزل أولًا الدفعتين المطبّقتين عليها.",
      "removeFirst_few": "أزل أولًا الدفعات الـ {{count}} المطبّقة عليها.",
      "removeFirst_many": "أزل أولًا الـ {{count}} دفعةً المطبّقة عليها.",
      "removeFirst_other": "أزل أولًا الـ {{count}} دفعة المطبّقة عليها.",
      "returnCreditFirst": "مرتجع المورد {{number}} مطبّق عليها: أزله من التسويات، أو ألغِ ذلك المرتجع، أولًا.",
      "returnFirst": "ألغِ أولًا مرتجع المورد {{number}} الصادر مقابلها."
    },
    "toast": {
      "saved": "حُفظت المسودة",
      "posted": "رُحّلت فاتورة الشراء {{number}}",
      "deleted": "حُذفت المسودة",
      "voided": "أُبطِل {{number}}",
      "payNext": "تسجيل الدفع للمورد؟",
      "savedDraft": "حُفظت كمسودة"
    },
    "list": {
      "daysLate_zero": "{{count}} ي",
      "daysLate_one": "يوم",
      "daysLate_two": "يومان",
      "daysLate_few": "{{count}} أيام",
      "daysLate_many": "{{count}} يومًا",
      "daysLate_other": "{{count}} يوم",
      "daysOverdueSpoken_zero": "غير متأخرة",
      "daysOverdueSpoken_one": "متأخرة يومًا واحدًا",
      "daysOverdueSpoken_two": "متأخرة يومين",
      "daysOverdueSpoken_few": "متأخرة {{count}} أيام",
      "daysOverdueSpoken_many": "متأخرة {{count}} يومًا",
      "daysOverdueSpoken_other": "متأخرة {{count}} يوم"
    },
    "figures": {
      "label": "أرقام فاتورة الشراء",
      "total": "الإجمالي",
      "vat": "منها ضريبة {{amount}}",
      "settled": "المسدد",
      "paidPart": "دُفع {{amount}}",
      "returnedPart": "أُرجع {{amount}}",
      "returned": "المرتجع",
      "nothingPaid": "لم يُسدد شيء بعد",
      "nothingOwed": "لا شيء مستحق",
      "settledInFull": "مسددة بالكامل",
      "overdue_zero": "غير متأخرة",
      "overdue_one": "متأخرة يومًا واحدًا",
      "overdue_two": "متأخرة يومين",
      "overdue_few": "متأخرة {{count}} أيام",
      "overdue_many": "متأخرة {{count}} يومًا",
      "overdue_other": "متأخرة {{count}} يوم",
      "dueToday": "تستحق اليوم",
      "dueIn_zero": "تستحق اليوم",
      "dueIn_one": "تستحق غدًا",
      "dueIn_two": "تستحق بعد يومين",
      "dueIn_few": "تستحق بعد {{count}} أيام",
      "dueIn_many": "تستحق بعد {{count}} يومًا",
      "dueIn_other": "تستحق بعد {{count}} يوم"
    },
    "duplicateTitle": "نسخ فاتورة شراء",
    "duplicateSubtitle": "نسخة من {{number}} بتاريخ اليوم. أدخل رقم فاتورة المورد الجديدة.",
    "duplicateFailed": "تعذّر تحميل فاتورة الشراء المراد نسخها. ابدأ من نموذج فارغ.",
    "saveAndPost": "حفظ وترحيل",
    "duplicate": {
      "title_zero": "فاتورة المورد {{reference}}",
      "title_one": "فاتورة المورد {{reference}} مسجلة على فاتورة شراء أخرى لهذا المورد",
      "title_two": "فاتورة المورد {{reference}} مسجلة على فاتورتي شراء أخريين لهذا المورد",
      "title_few": "فاتورة المورد {{reference}} مسجلة على {{count}} فواتير شراء أخرى لهذا المورد",
      "title_many": "فاتورة المورد {{reference}} مسجلة على {{count}} فاتورة شراء أخرى لهذا المورد",
      "title_other": "فاتورة المورد {{reference}} مسجلة على {{count}} فاتورة شراء أخرى لهذا المورد",
      "row": "بتاريخ {{date}}، الإجمالي {{total}}",
      "body": "تأكد أنها ليست الفاتورة نفسها مُدخلة مرتين. يمكنك الحفظ والترحيل مع ذلك."
    },
    "settlements": {
      "removed": "أُزيل {{number}} من فاتورة الشراء هذه",
      "removeTitle": "إزالة {{number}} من فاتورة الشراء هذه؟",
      "removeBody": "يعود {{amount}} إليه رصيدًا غير مطبّق، وتُفتح فاتورة الشراء من جديد بهذا المبلغ.",
      "removeNamed": "إزالة {{number}} من فاتورة الشراء هذه",
      "void": "لا شيء مطبّق: إنها ملغاة.",
      "recordOne": "سجّل دفعة"
    },
    "refShort": "مرجع المورد",
    "intoWarehouse": "إلى",
    "notes": "ملاحظات",
    "stats": {
      "label": "أرقام المشتريات",
      "open": "المستحق للدفع",
      "overdue": "المتأخرة",
      "thisMonth": "مشتريات هذا الشهر",
      "drafts": "المسودات",
      "draftsDetail": "بانتظار الترحيل",
      "overdueShare": "{{percent}}٪ من الرصيد المفتوح متأخر"
    }
  },
  "payments": {
    "title": "مدفوعات الموردين",
    "subtitle": "المبالغ المدفوعة للموردين وفواتير الشراء التي تسددها.",
    "kind": "دفعة لمورد",
    "new": "دفع مبلغ لمورد",
    "newTitle": "دفع مبلغ لمورد",
    "newSubtitle": "تُرحَّل إلى الدفاتر فورًا، ويُعيَّن الرقم عند الحفظ.",
    "save": "تسجيل الدفعة",
    "searchLabel": "البحث في مدفوعات الموردين",
    "searchPlaceholder": "ابحث بالرقم أو المرجع أو المورد…",
    "chooseSupplierFirst": "اختر المورد لعرض فواتير الشراء المفتوحة.",
    "remainder": "يبقى {{amount}} دفعة مقدّمة لدى المورد لتُطبّق على فواتير شراء لاحقة.",
    "creditTitle": "{{amount}} لم تُطبّق بعد",
    "creditBody": "المبلغ دفعة مقدّمة لدى المورد. طبّقه على فواتير الشراء عند ترحيلها.",
    "voidTitle": "هذه الدفعة مُبطَلة",
    "noAllocations": "لم تُطبّق هذه الدفعة على أي فاتورة شراء.",
    "noAllocationsHint": "طبّقها على فواتير الشراء المفتوحة للمورد.",
    "unallocateBody": "تعود فاتورة الشراء مفتوحة بهذا المبلغ، ويعود المبلغ دفعة مقدّمة لدى المورد.",
    "sections": {
      "payment": "الدفعة",
      "allocation": "التطبيق على فواتير الشراء",
      "allocations": "فواتير الشراء المسددة"
    },
    "fields": {
      "date": "تاريخ الدفع",
      "amount": "المبلغ المدفوع",
      "account": "دُفع من",
      "method": "طريقة الدفع"
    },
    "hints": {
      "reference": "رقم الشيك أو التحويل.",
      "allocation": "طبّق المبلغ على فواتير الشراء المفتوحة للمورد، الأقدم أولًا أو مبلغًا مبلغًا."
    },
    "actions": {
      "allocate": "التطبيق على فواتير الشراء",
      "void": "إبطال الدفعة",
      "allocateMenu": "تطبيق على فواتير الشراء…",
      "printVoucher": "طباعة السند",
      "voidMenu": "إلغاء…"
    },
    "allocate": {
      "title": "تطبيق {{number}}",
      "body": "لم يُطبَّق بعد {{amount}} من هذه الدفعة."
    },
    "void": {
      "title": "إبطال {{number}}؟",
      "body": "تُحرَّر المبالغ المطبّقة على فواتير الشراء ويُعكس قيدها اليومي. تبقى الدفعة في السجلات بحالة مُبطَلة.",
      "refundFirst": "ألغِ أولًا الاسترداد {{number}} المسحوب منه."
    },
    "refundChequeNotCleared": "لم يصرف البنك الشيك {{number}} بعد: يمكن الاسترداد بعد صرفه.",
    "toast": {
      "created": "سُجّلت الدفعة {{number}}",
      "allocated": "طُبّقت على فواتير الشراء",
      "unallocated": "أُزيل المبلغ من {{number}}",
      "voided": "أُبطِل {{number}}"
    },
    "empty": {
      "title": "لا توجد مدفوعات لموردين بعد.",
      "body": "سجّل مبلغًا دفعته لمورد.",
      "withCredit": "لا يوجد سند صرف برصيد غير مطبّق.",
      "void": "لا توجد سندات صرف ملغاة."
    },
    "views": {
      "label": "عروض سندات الصرف",
      "all": "الكل",
      "withCredit": "رصيد غير مطبّق",
      "void": "الملغاة",
      "unapplied": "غير مطبّق"
    },
    "advanceStamp": "دفعة مقدمة",
    "advanceHeld": "دفعة مقدمة لدى المورد",
    "saveAndPrint": "حفظ وطباعة",
    "stats": {
      "label": "أرقام مدفوعات الموردين",
      "paid": "المدفوع",
      "thisMonth": "المدفوع هذا الشهر",
      "credit": "رصيد غير مطبّق",
      "creditShare": "{{percent}}٪ من المدفوع لم يُطبَّق بعد",
      "overdue": "مشتريات متأخرة"
    }
  },
  "returns": {
    "title": "مرتجعات الموردين",
    "subtitle": "البضاعة المُعادة إلى الموردين والخصومات التي يمنحونها: إشعارات مدينة تخفّض ما ندين به.",
    "draftTitle": "مسودة مرتجع",
    "kind": {
      "RETURN": "مرتجع",
      "ALLOWANCE": "خصم مسموح به"
    },
    "kindHint": {
      "RETURN": "بضاعة أو خدمات تُعاد من فاتورة شراء مرحّلة. التكاليف والخصومات والضريبة تؤخذ من الفاتورة.",
      "ALLOWANCE": "تخفيض سعر يمنحه المورد، مع فاتورة شراء أو بدونها. لا يتحرك المخزون."
    },
    "new": "مرتجع مشتريات جديد",
    "newTitle": "مرتجع مشتريات جديد",
    "newSubtitle": "يُحفظ مسودةً، ويُعيَّن الرقم عند الترحيل.",
    "editTitle": "تعديل {{title}}",
    "editSubtitle": "تعديل المسودة",
    "saveDraft": "حفظ المسودة",
    "notDraftTitle": "لم يعد مرتجع المشتريات هذا مسودة",
    "backToReturn": "العودة إلى مرتجع المشتريات",
    "voidTitle": "مرتجع المشتريات هذا مُبطَل",
    "draftNote": "هذه مسودة: لم تُسجَّل في الدفاتر ولم يتحرك المخزون بعد. رحّلها لتخفيض ما ندين به للمورد.",
    "creditTitle": "{{amount}} لم تُطبّق بعد",
    "creditBody": "المبلغ رصيد دائن لنا لدى المورد. طبّقه على فواتير الشراء المفتوحة.",
    "applied": "المطبّق",
    "noAllocations": "لم يُطبّق مرتجع المشتريات هذا على أي فاتورة شراء.",
    "unallocateBody": "تعود فاتورة الشراء مفتوحة بهذا المبلغ، ويعود المبلغ رصيدًا لنا لدى المورد.",
    "remainder": "يبقى {{amount}} رصيدًا لنا لدى المورد.",
    "searchLabel": "البحث في مرتجعات الموردين",
    "searchPlaceholder": "ابحث بالرقم أو فاتورة الشراء أو المورد…",
    "kindFilter": "التصفية حسب النوع",
    "allKinds": "المرتجعات والخصومات",
    "purchaseWarehouse": "مستودع فاتورة الشراء",
    "purchaseWarehouseNamed": "مستودع فاتورة الشراء ({{code}})",
    "choosePurchase": "اختر فاتورة شراء",
    "chooseSupplierFirst": "اختر المورد أولًا",
    "searchPurchases": "ابحث برقم فاتورة الشراء…",
    "noPurchases": "لا توجد فواتير شراء مرحّلة من هذا المورد.",
    "noPurchase": "ليس على فاتورة شراء",
    "pickPurchase": "اختر فاتورة الشراء التي وردت بها البضاعة.",
    "pickPurchaseBody": "تظهر بنودها هنا مع المتبقي القابل للإرجاع من كل بند.",
    "returnAll": "إرجاع كل المتبقي",
    "purchased": "المشترى",
    "remaining": "المتبقي",
    "returnQuantity": "المرتجع",
    "returnQuantityOf": "الكمية المرتجعة من {{description}}",
    "credited": "المبلغ",
    "totalCredit": "إجمالي الخصم من المستحق",
    "sections": {
      "return": "مرتجع المشتريات",
      "returnLines": "البنود المرتجعة",
      "allocations": "فواتير الشراء المسددة",
      "document": "مستند المرتجع"
    },
    "fields": {
      "kind": "النوع",
      "date": "التاريخ",
      "warehouse": "الإخراج من المستودع",
      "reason": "السبب",
      "supplierReference": "رقم إشعار المورد الدائن",
      "supplierReferenceShort": "إشعار المورد"
    },
    "hints": {
      "returnPurchase": "لا يُرجع إلا من فاتورة شراء مرحّلة.",
      "allowancePurchase": "اختياري. عند اختيارها يتبع الخصم طريقة ضريبتها ويُطبّق عليها عند الترحيل.",
      "warehouse": "المستودع الذي تخرج منه البضاعة المرتجعة.",
      "reason": "يُطبع على الإشعار المدين.",
      "returnLines": "أدخل الكمية المُعادة لكل بند، بحد أقصى المتبقي القابل للإرجاع.",
      "allowanceLines": "صف ما يخصمه المورد مع ضريبته.",
      "supplierReference": "الرقم على الإشعار الدائن من المورد: المستند الذي يثبت تخفيض ضريبة المدخلات."
    },
    "errors": {
      "returnLimit": "إحدى الكميات أكبر من المتبقي القابل للإرجاع. صحّح البنود المظلّلة.",
      "noReturnLines": "أدخل كمية مرتجعة في بند واحد على الأقل.",
      "lineLimit": "المتبقي للإرجاع {{quantity}} فقط.",
      "serials": "الأرقام التسلسلية لا تطابق الكمية في البنود المظلّلة."
    },
    "actions": {
      "post": "ترحيل المرتجع",
      "apply": "التطبيق على فواتير الشراء",
      "delete": "حذف المسودة",
      "void": "إبطال مرتجع المشتريات",
      "postMenu": "ترحيل…",
      "deleteMenu": "حذف المسودة…",
      "applyMenu": "تطبيق على فواتير الشراء…",
      "voidMenu": "إلغاء…"
    },
    "post": {
      "title": "ترحيل مرتجع المشتريات هذا إلى {{supplier}}؟",
      "body": "الإجمالي {{total}}. يمنحه الترحيل رقمًا ويخفّض ما ندين به للمورد في الدفاتر. يبقى المبلغ رصيدًا لنا لدى المورد حتى يُطبّق على فاتورة شراء.",
      "bodyReturn": "الإجمالي {{total}}. يمنحه الترحيل رقمًا ويُخرج البضاعة المرتجعة من المخزون ويخفّض ما ندين به للمورد. يُطبّق تلقائيًا على {{purchase}} (المفتوح: {{open}}) بحد أقصى رصيدها المفتوح، ويبقى ما يزيد رصيدًا لنا لدى المورد.",
      "bodyPurchase": "الإجمالي {{total}}. يمنحه الترحيل رقمًا ويخفّض ما ندين به للمورد. يُطبّق تلقائيًا على {{purchase}} (المفتوح: {{open}}) بحد أقصى رصيدها المفتوح، ويبقى ما يزيد رصيدًا لنا لدى المورد."
    },
    "delete": {
      "title": "حذف هذه المسودة؟",
      "body": "تُحذف مسودة مرتجع المشتريات."
    },
    "apply": {
      "title": "تطبيق {{number}}",
      "body": "لم يُطبَّق بعد {{amount}} من مرتجع المشتريات هذا."
    },
    "void": {
      "title": "إبطال {{number}}؟",
      "body": "تُحرَّر المبالغ المطبّقة على فواتير الشراء ويُعكس قيده اليومي. يبقى مرتجع المشتريات في السجلات بحالة مُبطَل.",
      "bodyReturn": "تُحرَّر المبالغ المطبّقة على فواتير الشراء ويُعكس قيده اليومي وتعود البضاعة المرتجعة إلى المخزون. يبقى مرتجع المشتريات في السجلات بحالة مُبطَل.",
      "refundFirst": "ألغِ أولًا الاسترداد {{number}} المسحوب منه."
    },
    "toast": {
      "saved": "حُفظت المسودة",
      "posted": "رُحّل مرتجع المشتريات",
      "deleted": "حُذفت المسودة",
      "applied": "طُبّق على فواتير الشراء",
      "voided": "أُبطِل {{number}}",
      "postedNumber": "رُحّل مرتجع المورد {{number}}",
      "savedDraft": "حُفظ كمسودة"
    },
    "empty": {
      "title": "لا توجد مرتجعات مشتريات بعد.",
      "body": "أعد بضاعة من فاتورة شراء، أو سجّل تخفيض سعر منحك إياه مورد.",
      "drafts": "لا توجد مسودات مرتجعات.",
      "withCredit": "لا يوجد مرتجع برصيد غير مطبّق.",
      "void": "لا توجد مرتجعات ملغاة."
    },
    "views": {
      "label": "عروض المرتجعات",
      "all": "الكل",
      "drafts": "المسودات",
      "withCredit": "رصيد غير مطبّق",
      "void": "الملغاة"
    },
    "saveAndPost": "حفظ وترحيل",
    "refShort": "إشعار المورد",
    "against": "مقابل",
    "fromWarehouse": "من",
    "creditStamp": "رصيد",
    "creditHeld": "رصيد لنا لدى المورد",
    "stats": {
      "label": "أرقام المرتجعات",
      "drafts": "المسودات",
      "draftsDetail": "بانتظار الترحيل",
      "credit": "رصيد غير مطبّق",
      "thisMonth": "المرتجع هذا الشهر"
    }
  },
  "statement": {
    "title": "كشف حساب المورد",
    "balance": "الرصيد (ما ندين به)",
    "closing": "الرصيد الختامي (ما ندين به)",
    "hint": "من الدفاتر: فواتير الشراء دائنة، والدفعات والمرتجعات مدينة. الرصيد هو ما ندين به للمورد؛ والرصيد السالب رصيد لنا لديه.",
    "source": {
      "Purchase": "فاتورة شراء",
      "SupplierPayment": "دفعة لمورد",
      "SupplierReturn": "مرتجع مشتريات",
      "SupplierRefund": "استرداد من مورد",
      "journal": "قيد يومي"
    },
    "kind": {
      "PURCHASE": "فاتورة شراء",
      "PAYMENT": "سند صرف لمورد",
      "RETURN": "مرتجع مورد",
      "REFUND": "استرداد من مورد",
      "OTHER": "قيد آخر"
    },
    "creditHeld": "رصيد لنا لدى المورد",
    "weOwe": "المستحق علينا"
  },
  "aging": {
    "title": "أعمار الذمم الدائنة",
    "subtitle": "ما ندين به لكل مورد حسب مدة تأخره عن الاستحقاق، بعد خصم الدفعات والمرتجعات غير المستخدمة.",
    "searchLabel": "تصفية الموردين",
    "searchPlaceholder": "التصفية حسب المورد…",
    "credit": "رصيد غير مستخدم",
    "total": "ما ندين به",
    "empty": "لا ندين لأي مورد بشيء في هذا التاريخ.",
    "emptyBody": "تظهر هنا فواتير الشراء المرحّلة التي عليها رصيد مفتوح.",
    "hint": "تُحسب أيام التأخر من تاريخ استحقاق كل فاتورة شراء. المبالغ المطبّقة بعد التاريخ لا تُحتسب بعد.",
    "drill": "مشتريات {{supplier}}، {{bucket}}",
    "summary": {
      "title": "ما ندين به حسب العمر",
      "owed": "المستحق للموردين",
      "suppliers_zero": "لا موردين ندين لهم",
      "suppliers_one": "مورد واحد ندين له",
      "suppliers_two": "موردان ندين لهما",
      "suppliers_few": "{{count}} موردين ندين لهم",
      "suppliers_many": "{{count}} موردًا ندين لهم",
      "suppliers_other": "{{count}} مورد ندين لهم",
      "overdue": "متأخر السداد",
      "share": "{{share}} مما ندين به",
      "creditNote": "يُخصم مما ندين به",
      "bar": "أعمار ما ندين به",
      "narrowed": "الموردون الذين لهم رصيد في «{{column}}»",
      "showAll": "عرض الكل"
    }
  },
  "supplier": {
    "sections": "أقسام المورد",
    "overview": "نظرة عامة",
    "statement": "كشف الحساب",
    "attachments": "المرفقات",
    "newPurchase": "فاتورة شراء جديدة",
    "pay": "الدفع للمورد"
  },
  "refunds": {
    "title": "المبالغ المستردة من الموردين",
    "subtitle": "أرصدة استرددناها من الموردين: دفعات مقدمة ومرتجعات لم تُطبَّق على فواتير الشراء.",
    "kind": "مبلغ مسترد من مورد",
    "new": "تسجيل استرداد",
    "newTitle": "تسجيل مبلغ مسترد من مورد",
    "newSubtitle": "مبلغ استرددناه من المورد، يُرحَّل إلى الدفاتر فورًا. يُعيَّن الرقم عند الحفظ.",
    "searchLabel": "البحث في المبالغ المستردة",
    "searchPlaceholder": "ابحث بالرقم أو المرجع أو المورد…",
    "chooseSupplierFirst": "اختر المورد لعرض رصيدنا الدائن لديه.",
    "sections": {
      "refund": "الاسترداد"
    },
    "fields": {
      "date": "تاريخ الاسترداد",
      "account": "مستلم في",
      "amount": "المبلغ المستلم",
      "from": "من"
    },
    "source": {
      "PAYMENT": "دفعة",
      "SUPPLIER_RETURN": "مرتجع مورد"
    },
    "hints": {
      "credits": "الدفعات المقدمة والمرتجعات لدى هذا المورد التي لم تُطبَّق بعد على فواتير الشراء. استرد الرصيد كله أو جزءًا منه."
    },
    "credits": {
      "none": "لا يوجد لنا رصيد لدى هذا المورد.",
      "noneBody": "يظهر الرصيد هنا عندما لا تُطبَّق دفعة أو مرتجع على فواتير الشراء بالكامل.",
      "summary": "يُستلم {{amount}} من المورد."
    },
    "errors": {
      "noCredit": "أدخل مبلغًا من دفعة أو مرتجع واحد على الأقل.",
      "otherSupplier": "هذا الرصيد يخص موردًا آخر",
      "beforeCredit": "لا يمكن أن يسبق تاريخ الاسترداد تاريخ الرصيد المسترد"
    },
    "actions": {
      "refund": "تسجيل استرداد",
      "refundCredit": "استرداد",
      "printVoucher": "طباعة السند",
      "voidMenu": "إلغاء…"
    },
    "void": {
      "body": "يعود الرصيد إلى الدفعات والمرتجعات التي أُخذ منها، ويُعكس القيد اليومي. يبقى الاسترداد مسجلًا وعليه علامة الإبطال."
    },
    "toast": {
      "created": "سُجّل الاسترداد {{number}}"
    },
    "empty": {
      "title": "لا توجد مبالغ مستردة من الموردين بعد.",
      "body": "سجّل ما استرددناه من رصيدنا لدى المورد.",
      "void": "لا توجد استردادات ملغاة."
    },
    "views": {
      "label": "عروض الاستردادات",
      "all": "الكل",
      "void": "الملغاة"
    },
    "saveAndPrint": "حفظ وطباعة",
    "figures": {
      "fromPayments": "من سندات الصرف",
      "fromReturns": "من المرتجعات"
    },
    "stats": {
      "label": "أرقام الاستردادات",
      "received": "المستلم",
      "thisMonth": "المستلم هذا الشهر",
      "paymentCredit": "دفعات مقدمة للاسترداد",
      "returnCredit": "رصيد مرتجعات للاسترداد"
    }
  },
  "actions": {
    "open": "فتح",
    "print": "طباعة",
    "edit": "تعديل"
  },
  "detail": {
    "voidedOn": "أُلغي في {{date}}",
    "voidedOnBy": "ألغاه {{name}} في {{date}}",
    "purchasesSettled": "فواتير الشراء المسددة",
    "apply": "تطبيق",
    "unappliedNotice": "{{amount}} غير مطبّق بعد: طبّقه على فواتير الشراء المفتوحة، أو استرده من المورد.",
    "removeNamed_payment": "إزالة {{purchase}} من سند الصرف هذا",
    "removeNamed_return": "إزالة {{purchase}} من هذا المرتجع",
    "removeTitle_payment": "إزالة {{purchase}} من سند الصرف هذا؟",
    "removeTitle_return": "إزالة {{purchase}} من هذا المرتجع؟",
    "remove": "إزالة",
    "refundsDrawn": "الاستردادات منه",
    "postedAt": "رُحّل",
    "refShort": "المرجع",
    "noneVoid": "لا شيء مطبّق: إنه ملغى.",
    "purchaseCount_zero": "لا فواتير شراء",
    "purchaseCount_one": "فاتورة شراء واحدة",
    "purchaseCount_two": "فاتورتا شراء",
    "purchaseCount_few": "{{count}} فواتير شراء",
    "purchaseCount_many": "{{count}} فاتورة شراء",
    "purchaseCount_other": "{{count}} فاتورة شراء",
    "fullyApplied": "مطبّق بالكامل",
    "figures": "الأرقام",
    "totals": "الإجماليات"
  },
  "trail": {
    "slipNotApplied": "{{kind}} {{number}}، {{amount}}، {{status}}، غير مطبّق على فاتورة الشراء هذه",
    "settlements_zero": "سندات الصرف والمرتجعات: لا مستندات",
    "settlements_one": "سندات الصرف والمرتجعات: مستند واحد",
    "settlements_two": "سندات الصرف والمرتجعات: مستندان",
    "settlements_few": "سندات الصرف والمرتجعات: {{count}} مستندات",
    "settlements_many": "سندات الصرف والمرتجعات: {{count}} مستندًا",
    "settlements_other": "سندات الصرف والمرتجعات: {{count}} مستند",
    "purchases_zero": "فواتير الشراء المسددة: لا مستندات",
    "purchases_one": "فواتير الشراء المسددة: مستند واحد",
    "purchases_two": "فواتير الشراء المسددة: مستندان",
    "purchases_few": "فواتير الشراء المسددة: {{count}} مستندات",
    "purchases_many": "فواتير الشراء المسددة: {{count}} مستندًا",
    "purchases_other": "فواتير الشراء المسددة: {{count}} مستند"
  },
  "stats": {
    "allSuppliers": "جميع الموردين · {{documents}}",
    "monthDetail": "{{month}} · {{documents}}",
    "companyMonth": "جميع الموردين · {{month}}",
    "unavailable": "الأرقام غير متاحة",
    "purchases_zero": "لا فواتير شراء",
    "purchases_one": "فاتورة شراء واحدة",
    "purchases_two": "فاتورتا شراء",
    "purchases_few": "{{n}} فواتير شراء",
    "purchases_many": "{{n}} فاتورة شراء",
    "purchases_other": "{{n}} فاتورة شراء",
    "payments_zero": "لا دفعات",
    "payments_one": "دفعة واحدة",
    "payments_two": "دفعتان",
    "payments_few": "{{n}} دفعات",
    "payments_many": "{{n}} دفعة",
    "payments_other": "{{n}} دفعة",
    "returns_zero": "لا مرتجعات",
    "returns_one": "مرتجع واحد",
    "returns_two": "مرتجعان",
    "returns_few": "{{n}} مرتجعات",
    "returns_many": "{{n}} مرتجعًا",
    "returns_other": "{{n}} مرتجع",
    "refunds_zero": "لا استردادات",
    "refunds_one": "استرداد واحد",
    "refunds_two": "استردادان",
    "refunds_few": "{{n}} استردادات",
    "refunds_many": "{{n}} استردادًا",
    "refunds_other": "{{n}} استرداد"
  },
  "serials": {
    "wholeUnits": "المنتجات ذات الأرقام التسلسلية تُعدّ بوحدات كاملة.",
    "incomplete": "الأرقام التسلسلية {{entered}} من {{quantity}}: الترحيل يتطلب رقمًا لكل وحدة.",
    "over": "الأرقام التسلسلية ({{entered}}) أكثر من الوحدات ({{quantity}}): احذف بعضها أو زِد الكمية.",
    "named": "{{message}}: {{serials}}",
    "errors": {
      "SERIAL_COUNT_MISMATCH": "الأرقام التسلسلية لا تطابق الكمية: الترحيل يتطلب رقمًا لكل وحدة، وبوحدات كاملة",
      "SERIAL_DUPLICATE": "موجود في المخزون أو مُباع أو مكرّر",
      "SERIAL_NOT_AVAILABLE": "غير متوفر في مستودع المرتجع",
      "SERIALS_NOT_TRACKED": "هذا المنتج لا يتتبّع الأرقام التسلسلية: امسحها",
      "SERIAL_MOVED_ON": "بِيع أو أُرجع أو نُقل منذ ذلك الحين"
    }
  },
  "capture": {
    "action": "تعبئة من قائمة أو مستند",
    "newFromDocument": "فاتورة شراء من مستند",
    "title": "تعبئة من قائمة أو مستند",
    "description": "يقرؤها المساعد ويملأ نموذج فاتورة الشراء. تراجع النموذج وتحفظه كالمعتاد؛ لا يُحفظ شيء هنا.",
    "prompt": "اقرأ فاتورة الشراء هذه من فاتورة المورد أو من القائمة، واملأ النموذج.",
    "read": "قراءة وتعبئة",
    "needsInput": "اكتب قائمة، أو أضف صورة أو ملف PDF للفاتورة، أولًا.",
    "or": "أو",
    "list": {
      "label": "قائمة الأصناف",
      "hint": "صنف في كل سطر: الكمية والصنف والسعر إن وُجد. ويمكن كتابة المورد ورقم الفاتورة في سطر مستقل.",
      "placeholder": "10 أكياس أسمنت بسعر 1.850\n5 حديد تسليح 12 مم بسعر 3.200"
    },
    "drop": {
      "title": "أفلت صور الفاتورة أو ملف PDF لها هنا",
      "choose": "اختيار ملفات",
      "photo": "التقاط صورة",
      "rules_zero": "صور (JPG وPNG وWebP) أو ملف PDF حتى {{pages}} صفحات، بحدٍّ أقصى {{limit}} للملف. تُصغَّر الصور الكبيرة قبل إرسالها.",
      "rules_one": "ملف واحد كحدٍّ أقصى: صورة (JPG أو PNG أو WebP) أو ملف PDF حتى {{pages}} صفحات، بحدٍّ أقصى {{limit}}. تُصغَّر الصور الكبيرة قبل إرسالها.",
      "rules_two": "ملفان كحدٍّ أقصى: صور (JPG وPNG وWebP) أو ملف PDF حتى {{pages}} صفحات، بحدٍّ أقصى {{limit}} للملف. تُصغَّر الصور الكبيرة قبل إرسالها.",
      "rules_few": "حتى {{n}} ملفات: صور (JPG وPNG وWebP) أو ملف PDF حتى {{pages}} صفحات، بحدٍّ أقصى {{limit}} للملف. تُصغَّر الصور الكبيرة قبل إرسالها.",
      "rules_many": "حتى {{n}} ملفًا: صور (JPG وPNG وWebP) أو ملف PDF حتى {{pages}} صفحات، بحدٍّ أقصى {{limit}} للملف. تُصغَّر الصور الكبيرة قبل إرسالها.",
      "rules_other": "حتى {{n}} ملف: صور (JPG وPNG وWebP) أو ملف PDF حتى {{pages}} صفحات، بحدٍّ أقصى {{limit}} للملف. تُصغَّر الصور الكبيرة قبل إرسالها.",
      "titleTouch": "صورة الفاتورة أو ملف PDF لها"
    },
    "files": {
      "label": "المستندات المراد قراءتها",
      "remove": "إزالة {{name}}"
    },
    "refused": {
      "type": "لا يُقرأ إلا الصور (JPG وPNG وWebP) وملفات PDF.",
      "empty": "هذا الملف فارغ.",
      "size": "حجمه أكبر من {{limit}} حتى بعد تصغيره. صوّر الفاتورة صفحةً صفحة، أو احفظ ملف PDF أصغر.",
      "count_zero": "لا يمكن إضافة مستندات أخرى.",
      "count_one": "لا يُقرأ إلا مستند واحد في المرة الواحدة. أزله لتضيف غيره.",
      "count_two": "لا يُقرأ أكثر من مستندين في المرة الواحدة. أزل واحدًا لتضيف غيره.",
      "count_few": "لا يُقرأ أكثر من {{n}} مستندات في المرة الواحدة. أزل واحدًا لتضيف غيره.",
      "count_many": "لا يُقرأ أكثر من {{n}} مستندًا في المرة الواحدة. أزل واحدًا لتضيف غيره.",
      "count_other": "لا يُقرأ أكثر من {{n}} مستند في المرة الواحدة. أزل واحدًا لتضيف غيره."
    },
    "privacy": {
      "short": "لا يُحتفظ بالمستند؛ ويبقى ما تكتبه في سجل المساعد لديك طوال مدة الاحتفاظ التي تحددها شركتك.",
      "details": "التفاصيل",
      "sent": "ما تكتبه والمستند كاملًا يُرسَلان إلى OpenAI عبر مفتاح شركتك، بكل ما هو مكتوب عليه: عنوان المورد وهاتفه ورقمه الضريبي أيضًا.",
      "kept": "لا يحتفظ المساعد بالمستند. أما ما تكتبه فيُحفظ رسالةً منك في سجل المساعد، ويُحذف وفق قاعدة الاحتفاظ في شركتك.",
      "attached": "النسخة التي تبقى هي المرفقة بفاتورة الشراء عند الحفظ."
    },
    "progress": {
      "preparing": "جارٍ تصغير الصور…",
      "reading": "جارٍ قراءة المستند…",
      "readingList": "جارٍ قراءة القائمة…",
      "supplier": "جارٍ البحث عن المورد…",
      "products": "جارٍ مطابقة المنتجات…",
      "filling": "جارٍ التحقق من الأرقام وتعبئة النموذج…"
    },
    "replace": {
      "title": "استبدال البنود الموجودة في النموذج؟",
      "confirm": "استبدال وقراءة",
      "cancel": "الإبقاء على بنودي",
      "body_zero": "لا بنود أدخلتها في النموذج.",
      "body_one": "في النموذج بند واحد أدخلته. القراءة تستبدل البنود في النموذج.",
      "body_two": "في النموذج بندان أدخلتهما. القراءة تستبدل البنود في النموذج.",
      "body_few": "في النموذج {{n}} بنود أدخلتها. القراءة تستبدل البنود في النموذج.",
      "body_many": "في النموذج {{n}} بندًا أدخلتها. القراءة تستبدل البنود في النموذج.",
      "body_other": "في النموذج {{n}} بند أدخلتها. القراءة تستبدل البنود في النموذج."
    },
    "errors": {
      "FILE_TOO_LARGE": "أحد المستندات أكبر من {{limit}}. أزله، أو استخدم صورة أو ملف PDF أصغر، ثم أعد القراءة.",
      "UNSUPPORTED_FILE_TYPE": "أحد المستندات ليس صورة أو ملف PDF يستطيع المساعد قراءته. أزله، أو احفظه بصيغة JPG أو PNG أو WebP أو PDF، ثم أعد القراءة.",
      "AI_ATTACHMENTS_NOT_ACCEPTED": "لا يستقبل المساعد مستندات هنا حاليًا. اكتب القائمة بدلًا من ذلك، أو تواصل مع المسؤول.",
      "budget": "استُنفد رصيد المساعد الذكي لشركتك هذا الشهر. أدخل فاتورة الشراء يدويًا، أو اطلب من المسؤول رفعه في الإعدادات › المساعد الذكي.",
      "dailyLimit": "استنفدت تشغيلات المساعد المتاحة لك اليوم. أدخل فاتورة الشراء يدويًا، أو اقرأها غدًا.",
      "prefill": "تعذّر التحقق مما قُرئ",
      "AI_TOO_MANY_ATTACHMENTS_zero": "لا يمكن قراءة مستندات في هذه المرة.",
      "AI_TOO_MANY_ATTACHMENTS_one": "لا يُقرأ إلا مستند واحد في المرة الواحدة. أزل الباقي ثم أعد القراءة.",
      "AI_TOO_MANY_ATTACHMENTS_two": "لا يُقرأ أكثر من مستندين في المرة الواحدة. أزل بعضها ثم أعد القراءة.",
      "AI_TOO_MANY_ATTACHMENTS_few": "لا يُقرأ أكثر من {{n}} مستندات في المرة الواحدة. أزل بعضها ثم أعد القراءة.",
      "AI_TOO_MANY_ATTACHMENTS_many": "لا يُقرأ أكثر من {{n}} مستندًا في المرة الواحدة. أزل بعضها ثم أعد القراءة.",
      "AI_TOO_MANY_ATTACHMENTS_other": "لا يُقرأ أكثر من {{n}} مستند في المرة الواحدة. أزل بعضها ثم أعد القراءة.",
      "AI_DOCUMENT_TOO_LONG": "في ملف PDF هذا {{pages}} صفحة، والحد الأقصى {{max}}. أرسل صفحات الفاتورة على أجزاء.",
      "AI_DOCUMENT_TOO_LONG_unknown": "صفحات ملف PDF هذا أكثر من الحد الأقصى ({{max}}). أرسل صفحات الفاتورة على أجزاء.",
      "AI_BUSY": "المساعد يقرأ مستندات أخرى الآن. حاول مرة أخرى بعد دقيقة."
    },
    "warnings": {
      "CREDIT_NOTE": {
        "title": "هذا إشعار دائن، وليس فاتورة",
        "body": "سجّله مرتجعَ مشتريات إلى المورد بدلًا من ذلك، حتى يُخفّض ما عليك له."
      },
      "NOT_A_BILL": {
        "title": "لا يبدو هذا فاتورة مورد",
        "body": "تأكد أنه فاتورة قبل الحفظ: الفاتورة وحدها تزيد ما عليك للمورد.",
        "QUOTATION": {
          "title": "هذا عرض سعر، وليس فاتورة",
          "body": "لا يُستحق شيء بعرض السعر. احفظ الشراء فقط عندما يرسل المورد فاتورته."
        },
        "DELIVERY_NOTE": {
          "title": "هذا إشعار تسليم، وليس فاتورة",
          "body": "يبيّن ما سُلّم لا ما عليك دفعه. أدخل الشراء من فاتورة المورد."
        },
        "OTHER": {
          "title": "لا يبدو هذا فاتورة مورد",
          "body": "تأكد أنه فاتورة قبل الحفظ: الفاتورة وحدها تزيد ما عليك للمورد."
        }
      },
      "SUPPLIER_TAX_MISMATCH": {
        "title": "الرقم الضريبي على الفاتورة ليس رقم هذا المورد",
        "body": "تذكر الفاتورة {{onBill}}، والمسجّل لهذا المورد {{onFile}}. تحقّق من المورد قبل الحفظ."
      },
      "SUPPLIER_NOT_FOUND": {
        "title": "مورد الفاتورة ليس من مورديك",
        "titleNamed": "«{{name}}» ليس من مورديك",
        "body": "اختر المورد الصحيح في النموذج، أو أضِف هذا المورد موردًا جديدًا. وطابِق رقمه الضريبي مع الفاتورة."
      },
      "SUPPLIER_INACTIVE": {
        "title": "مورد الفاتورة غير نشط",
        "titleNamed": "المورد «{{name}}» غير نشط",
        "body": "تُرك حقل المورد فارغًا. اختر موردًا آخر، أو اطلب إعادة تنشيط هذا المورد من قائمة الموردين."
      },
      "DUPLICATE_BILL": {
        "title": "قد تكون هذه الفاتورة مُدخلة من قبل",
        "body": "رقم فاتورة المورد نفسه مسجّل على فواتير الشراء أدناه. افتحها وتحقق منها قبل حفظ هذه."
      },
      "TOTAL_MISMATCH": {
        "title": "مجموع البنود لا يطابق إجمالي المستند",
        "body": "كما قُرئت، مجموع البنود {{computed}} والمستند يذكر {{document}}. طابِق الكميات والأسعار والضريبة معه؛ يُقارَن الإجماليان تحت البنود أثناء التصحيح.",
        "netTitle": "صافي البنود لا يطابق صافي المستند",
        "netBody": "لم يُقرأ المبلغ المستحق، فيُقارَن الصافيان: كما قُرئت، صافي البنود (قبل الضريبة) {{computed}} وصافي المستند {{document}}. طابِق الكميات والأسعار والخصومات معه؛ يُقارَن الصافيان تحت البنود أثناء التصحيح."
      },
      "FOREIGN_CURRENCY": {
        "title": "المستند بعملة {{currency}} وليس بالريال العماني",
        "body": "عُبّئت المبالغ كما كُتبت. حوّلها إلى الريال العماني قبل الحفظ."
      },
      "PRICE_BASIS_CONVERTED": {
        "titleToInclusive": "أسعار المستند قبل الضريبة",
        "titleToExclusive": "أسعار المستند شاملة الضريبة",
        "body": "تُدخل شركتك أسعار الشراء بالطريقة الأخرى، فحُوّل سعر كل وحدة بنسبة ضريبة بندها. طابِق إجماليات البنود مع المستند."
      },
      "LINES_TRUNCATED": {
        "title": "في المستند بنود أكثر مما قُرئ",
        "body_zero": "لم يُعبَّأ أي بند. أضف البنود يدويًا.",
        "body_one": "عُبّئ البند الأول فقط. أضف الباقي يدويًا.",
        "body_two": "عُبّئ أول بندين فقط. أضف الباقي يدويًا.",
        "body_few": "عُبّئت أول {{n}} بنود فقط. أضف الباقي يدويًا.",
        "body_many": "عُبّئ أول {{n}} بندًا فقط. أضف الباقي يدويًا.",
        "body_other": "عُبّئ أول {{n}} بند فقط. أضف الباقي يدويًا."
      },
      "DATE_MISSING": {
        "title": "لم يُقرأ تاريخ",
        "body": "استُخدم تاريخ اليوم. عدّله إلى تاريخ الفاتورة إن اختلف."
      },
      "NOTHING_READ": {
        "title": "تعذّرت قراءة أي بند",
        "body": "جرّب صورة أوضح تظهر فيها الفاتورة كاملة، أو اكتب القائمة."
      }
    },
    "review": {
      "fromDocument": "قُرئت من المستند",
      "fromList": "قُرئت من قائمتك",
      "notSaved": "غير محفوظة",
      "introDocument": "طابِق كل بند مع المستند، وصحّح ما يلزم، ثم احفظ كالمعتاد. لا يُحفظ شيء قبل ذلك.",
      "introList": "راجع كل بند، وصحّح ما يلزم، ثم احفظ كالمعتاد. لا يُحفظ شيء قبل ذلك.",
      "showDocument": "عرض المستند",
      "hideDocument": "إخفاء المستند",
      "startOver": "البدء من جديد",
      "figures": "ما قُرئ",
      "linesRead": "البنود المقروءة",
      "linesReadSub": "معبّأة أدناه",
      "matched": "مطابقة لمنتج",
      "matchedAll": "كل البنود",
      "toCheck": "للمراجعة",
      "toCheckSub": "معلَّمة على البنود",
      "toCheckNone": "لا شيء معلَّم",
      "documentTotal": "إجمالي المستند",
      "documentNet": "صافي المستند",
      "notes": "ملاحظات المساعد",
      "textLines_zero": "لا بنود نصية",
      "textLines_one": "بند واحد بقي نصيًا",
      "textLines_two": "بندان بقيا نصيين",
      "textLines_few": "{{n}} بنود بقيت نصية",
      "textLines_many": "{{n}} بندًا بقيت نصية",
      "textLines_other": "{{n}} بند بقيت نصية",
      "attached_zero": "لا مستندات ضمن المرفقات.",
      "attached_one": "المستند ضمن المرفقات أدناه: يُحفظ مع فاتورة الشراء عند الحفظ.",
      "attached_two": "المستندان ضمن المرفقات أدناه: يُحفظان مع فاتورة الشراء عند الحفظ.",
      "attached_few": "المستندات ({{count}}) ضمن المرفقات أدناه: تُحفظ مع فاتورة الشراء عند الحفظ.",
      "attached_many": "المستندات ({{count}}) ضمن المرفقات أدناه: تُحفظ مع فاتورة الشراء عند الحفظ.",
      "attached_other": "المستندات ({{count}}) ضمن المرفقات أدناه: تُحفظ مع فاتورة الشراء عند الحفظ.",
      "notAttached_zero": "المستندات غير مرفقة: لا تملك صلاحية إضافة مرفقات لفواتير الشراء. احتفظ بالنسخ الورقية.",
      "notAttached_one": "المستند غير مرفق: لا تملك صلاحية إضافة مرفقات لفواتير الشراء. احتفظ بالنسخة الورقية.",
      "notAttached_two": "المستندان غير مرفقين: لا تملك صلاحية إضافة مرفقات لفواتير الشراء. احتفظ بالنسختين الورقيتين.",
      "notAttached_few": "المستندات غير مرفقة: لا تملك صلاحية إضافة مرفقات لفواتير الشراء. احتفظ بالنسخ الورقية.",
      "notAttached_many": "المستندات غير مرفقة: لا تملك صلاحية إضافة مرفقات لفواتير الشراء. احتفظ بالنسخ الورقية.",
      "notAttached_other": "المستندات غير مرفقة: لا تملك صلاحية إضافة مرفقات لفواتير الشراء. احتفظ بالنسخ الورقية.",
      "toCheckNext": "الانتقال إلى التالي",
      "done": "تم",
      "detached_zero": "أُزيلت المستندات من المرفقات: لن تُحفظ مع فاتورة الشراء.",
      "detached_one": "أُزيل المستند من المرفقات: لن يُحفظ مع فاتورة الشراء.",
      "detached_two": "أُزيل المستندان من المرفقات: لن يُحفظا مع فاتورة الشراء.",
      "detached_few": "أُزيلت المستندات من المرفقات: لن تُحفظ مع فاتورة الشراء.",
      "detached_many": "أُزيلت المستندات من المرفقات: لن تُحفظ مع فاتورة الشراء.",
      "detached_other": "أُزيلت المستندات من المرفقات: لن تُحفظ مع فاتورة الشراء.",
      "attachedSome_zero": "{{n}} من {{total}} مستندات ضمن المرفقات أدناه؛ والباقي لن يُحفظ مع فاتورة الشراء.",
      "attachedSome_one": "{{n}} من {{total}} مستندات ضمن المرفقات أدناه؛ والباقي لن يُحفظ مع فاتورة الشراء.",
      "attachedSome_two": "{{n}} من المستندين ضمن المرفقات أدناه؛ والآخر لن يُحفظ مع فاتورة الشراء.",
      "attachedSome_few": "{{n}} من {{total}} مستندات ضمن المرفقات أدناه؛ والباقي لن يُحفظ مع فاتورة الشراء.",
      "attachedSome_many": "{{n}} من {{total}} مستندًا ضمن المرفقات أدناه؛ والباقي لن يُحفظ مع فاتورة الشراء.",
      "attachedSome_other": "{{n}} من {{total}} مستند ضمن المرفقات أدناه؛ والباقي لن يُحفظ مع فاتورة الشراء.",
      "summary_zero": "لم يُعبَّأ أي بند؛ وللمراجعة {{toCheck}}.",
      "summary_one": "عُبّئ بند واحد؛ وللمراجعة {{toCheck}}.",
      "summary_two": "عُبّئ بندان؛ وللمراجعة {{toCheck}}.",
      "summary_few": "عُبّئت {{n}} بنود؛ وللمراجعة {{toCheck}}.",
      "summary_many": "عُبّئ {{n}} بندًا؛ وللمراجعة {{toCheck}}.",
      "summary_other": "عُبّئ {{n}} بند؛ وللمراجعة {{toCheck}}.",
      "announce": {
        "toCheck_zero": "لا شيء للمراجعة.",
        "toCheck_one": "بقي بند واحد للمراجعة.",
        "toCheck_two": "بقي بندان للمراجعة.",
        "toCheck_few": "بقيت {{n}} بنود للمراجعة.",
        "toCheck_many": "بقي {{n}} بندًا للمراجعة.",
        "toCheck_other": "بقي {{n}} بند للمراجعة.",
        "none": "لم يبقَ شيء للمراجعة."
      },
      "vatMatches": "الرقم الضريبي مطابق",
      "matchedByTax": "اختير برقمه الضريبي",
      "notSameBill": "ليست الفاتورة نفسها",
      "addSupplier": "إضافة هذا المورد",
      "recordReturn": "تسجيل مرتجع للمورد"
    },
    "startOver": {
      "title": "البدء من جديد؟",
      "body": "تُفرَّغ البنود في النموذج وما قُرئ، مع أي تغييرات أجريتها، ويُزال المستند من المرفقات.",
      "cancel": "الإبقاء على النموذج",
      "bodyList": "تُفرَّغ البنود في النموذج وما قُرئ من قائمتك، مع أي تغييرات أجريتها."
    },
    "viewer": {
      "title": "المستند",
      "description": "طابِق أرقام النموذج معه.",
      "zoomIn": "تكبير",
      "zoomOut": "تصغير",
      "open": "فتح في علامة تبويب جديدة",
      "openPdf": "فتح ملف PDF",
      "pdfHere": "يعرض هذا المتصفح ملف PDF في علامة تبويب مستقلة.",
      "pages": "المستندات المقروءة",
      "page": "المستند {{n}} من {{total}}: {{name}}",
      "frame": "المستند (يُمرَّر عند التكبير)",
      "alt": "{{name}}، المستند المقروء"
    },
    "line": {
      "onDocument": "في الفاتورة:",
      "code": "الرمز",
      "chooseProduct": "اختر منتجًا",
      "check": "راجِع هذا البند",
      "issues": {
        "NO_PRODUCT": "لم يطابق أي منتج. اختر منتجًا، أو أبقه بندًا نصيًا: البند النصي يُحمَّل على حساب مصروفات ولا يدخل المخزون.",
        "PRODUCT_UNAVAILABLE": "المنتج المطابق مؤرشف أو لا يمكن شراؤه، فصار البند نصيًا: يُحمَّل على حساب مصروفات ولا يدخل المخزون. اختر منتجًا آخر، أو أبقه نصيًا.",
        "LOW_CONFIDENCE": "لم يكن المساعد متأكدًا من هذا البند. طابِق المنتج والأرقام مع المستند.",
        "QUANTITY_UNREADABLE": "تعذّرت قراءة الكمية، فاستُخدم 1.",
        "PRICE_FROM_TOTAL": "لم يُقرأ سعر الوحدة: حُسب من إجمالي البند.",
        "PRICE_LAST_COST": "لم يُقرأ سعر: استُخدمت تكلفة المنتج المسجّلة. تحقّق منها.",
        "PRICE_MISSING": "لم يُقرأ سعر ولا توجد تكلفة مسجّلة، فهو 0.000: أدخل السعر.",
        "WHOLE_UNITS": "هذا المنتج يُعدّ بوحدات كاملة، لكن الكمية المقروءة فيها كسر.",
        "LINE_TOTAL_MISMATCH": "الكمية × السعر لا تساوي إجمالي البند المطبوع على المستند.",
        "TAX_RATE_UNKNOWN": "نسبة الضريبة على المستند ليست من نسب شركتك، فلم تُستخدم. تحقّق من نسبة ضريبة هذا البند."
      },
      "inList": "في قائمتك:",
      "productChosen": "اختير منتج",
      "changed": "عُدّلت الأرقام",
      "done": "(تم)",
      "markChecked": "تأكيد المراجعة",
      "markCheckedOf": "تأكيد المراجعة، البند {{n}}",
      "keepText": "إبقاؤه بندًا نصيًا",
      "keepTextOf": "إبقاؤه بندًا نصيًا، البند {{n}}",
      "keepTextHint": "لن يدخل المخزون",
      "undo": "تراجع",
      "undoOf": "تراجع، البند {{n}}",
      "announce": {
        "checked": "تم تأكيد مراجعة البند {{n}}.",
        "kept": "أُبقي البند {{n}} بندًا نصيًا.",
        "undone": "عادت ملاحظات البند {{n}}."
      }
    },
    "totals": {
      "document": "إجمالي المستند",
      "differ": "بين مجموع البنود وإجمالي المستند فرق {{difference}}. طابِق الكميات والأسعار والضريبة معه.",
      "match": "يطابق إجمالي المستند.",
      "documentNet": "صافي المستند",
      "differNet": "بين صافي البنود وصافي المستند فرق {{difference}}. طابِق الكميات والأسعار والخصومات معه.",
      "matchNet": "يطابق صافي المستند."
    },
    "supplierOnBill": "في الفاتورة:",
    "supplierInList": "في قائمتك:"
  }
}
